module.exports = __webpack_public_path__ + "static/img/color.895106db.jpg";